import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';

class WaterTester {
  constructor({
    id, name, branchID, created, modified, imported, deleted,
  }) {
    this.id = id;
    this.name = name;
    this.branchID = branchID;
    this.created = created;
    this.modified = modified;
    this.imported = imported;
    this.deleted = deleted;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      Name: this.name,
      BranchID: this.branchID,
      Created: moment(this.created),
      Modified: moment(this.modified),
      Imported: moment(this.imported),
      Deleted: this.deleted,
    };
  }

  static fromApiFormat(api) {
    return new WaterTester({
      id: api.ID,
      name: api.Name,
      branchID: api.BranchID,
      created: api.Created,
      modified: api.Modified,
      imported: api.Imported,
      deleted: api.Deleted,
    });
  }
}

export default WaterTester;
